export function Generate(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.20947 0.623921C9.98753 0.517074 10.7717 0.771878 11.3384 1.31565L13.176 3.07904C13.4173 3.31062 13.7773 3.36763 14.0783 3.22196L16.3709 2.11273C17.6485 1.49459 19.1853 2.02918 19.8035 3.30677C20.1455 4.01373 20.1455 4.8383 19.8035 5.54526L18.6942 7.83785C18.5486 8.13893 18.6056 8.49886 18.8372 8.74018L20.6005 10.5778C21.5832 11.6018 21.5497 13.2286 20.5257 14.2113C19.959 14.7551 19.1748 15.0099 18.3967 14.903L15.8736 14.5565C15.5422 14.511 15.2175 14.6765 15.0596 14.9713L13.8568 17.2162C13.1865 18.4673 11.629 18.9381 10.378 18.2678C9.68572 17.8969 9.20105 17.2299 9.06223 16.4569L8.772 14.84L2.54853 21.0647C2.0799 21.5334 1.3201 21.5334 0.851472 21.0647C0.382843 20.5961 0.382843 19.8363 0.851472 19.3677L7.074 13.144L5.45934 12.854C4.11829 12.6131 3.20841 11.3724 3.35972 10.0376L3.3842 9.87037C3.52302 9.09737 4.00768 8.43028 4.69995 8.05939L6.94489 6.85663C7.23971 6.69868 7.40515 6.37399 7.35965 6.04263L7.01315 3.51948C6.82007 2.11339 7.80339 0.817011 9.20947 0.623921ZM9.53598 3.00161C9.44306 3.01437 9.37808 3.10004 9.39084 3.19296L9.73733 5.71611C9.91935 7.04155 9.25759 8.34032 8.0783 8.97214L5.83337 10.1749C5.78762 10.1994 5.75559 10.2435 5.74641 10.2946C5.72984 10.3869 5.79123 10.4752 5.88355 10.4917L8.39028 10.9419C9.70709 11.1784 10.7378 12.2091 10.9743 13.5259L11.4244 16.0326C11.4336 16.0837 11.4656 16.1278 11.5114 16.1523C11.5941 16.1966 11.697 16.1655 11.7413 16.0828L12.9441 13.8379C13.5759 12.6586 14.8746 11.9968 16.2001 12.1789L18.7232 12.5254C18.7747 12.5324 18.8265 12.5156 18.864 12.4797C18.9316 12.4147 18.9338 12.3072 18.8689 12.2395L17.1055 10.4019C16.1792 9.43659 15.9511 7.99689 16.5338 6.79257L17.6431 4.49998C17.6657 4.45326 17.6657 4.39877 17.6431 4.35205C17.6022 4.26762 17.5006 4.23229 17.4162 4.27314L15.1236 5.38237C13.9193 5.96506 12.4796 5.73704 11.5143 4.81071L9.67668 3.04732C9.63923 3.01138 9.5874 2.99455 9.53598 3.00161Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
